var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImport = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "import"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.9 12.4917C9.74167 12.4917 9.58333 12.4333 9.45833 12.3083L7.325 10.175C7.08333 9.93333 7.08333 9.53333 7.325 9.29167C7.56667 9.05 7.96667 9.05 8.20833 9.29167L9.9 10.9833L11.5917 9.29167C11.8333 9.05 12.2333 9.05 12.475 9.29167C12.7167 9.53333 12.7167 9.93333 12.475 10.175L10.3417 12.3083C10.2167 12.4333 10.0583 12.4917 9.9 12.4917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.9 12.4333C9.55833 12.4333 9.275 12.15 9.275 11.8083V3.33333C9.275 2.99167 9.55833 2.70833 9.9 2.70833C10.2417 2.70833 10.525 2.99167 10.525 3.33333V11.8083C10.525 12.15 10.2417 12.4333 9.9 12.4333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 17.4417C5.70833 17.4417 2.70833 14.4417 2.70833 10.15C2.70833 9.80833 2.99167 9.525 3.33333 9.525C3.675 9.525 3.95833 9.80833 3.95833 10.15C3.95833 13.7083 6.44167 16.1917 10 16.1917C13.5583 16.1917 16.0417 13.7083 16.0417 10.15C16.0417 9.80833 16.325 9.525 16.6667 9.525C17.0083 9.525 17.2917 9.80833 17.2917 10.15C17.2917 14.4417 14.2917 17.4417 10 17.4417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    opacity: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/import.f2eafef229133db87e9f47b8e22e3c63.svg";